import { ThunkAction } from '@reduxjs/toolkit';
import { fetchMoreFailed, fetchMoreRequested, fetchMoreSucceeded } from './index';
import { Region } from 'stores/type';
import { ErrorResponse } from 'helpers/type';

export type TPagingParams = {
    pageSize: number;
    page: number;
};

export enum EBillsStatus {
    DueNow = 'Due now',
    Paid = 'Paid',
    Credited = 'Credited',
}

export interface IBill {
    invoiceDate: string;
    invoiceNumber: string;
    totalDue?: number;
    region: Region;
    status: EBillsStatus;
    billingStartDate: string;
    billingEndDate: string;
    totalAmount: number;
    downloadId: string;
}

export interface IBillHistory {
    data: IBill[];
    meta: {
        totalRecords: number;
        page: number;
        pageSize: number;
    };
    isLoading: boolean;
}

export interface IBillsState {
    isLoading: boolean;
    isError: boolean;
    latest: IBill | null;
    history: IBillHistory;
    error: ErrorResponse | null;
    isDownloading: boolean;
}

export type TFetchMoreActions =
    | ReturnType<typeof fetchMoreRequested>
    | ReturnType<typeof fetchMoreSucceeded>
    | ReturnType<typeof fetchMoreFailed>;

export type TFetchMoreThunkAction = ThunkAction<Promise<void>, IBillsState, null, TFetchMoreActions>;
